import showErrorSnackbar from '../../Components/Snackbar/errorSnackbar'
import { ErrorCodes } from './errorCodes'

const extractStrings = (data) => {
  const strings = []

  const recursiveExtract = (obj) => {
    Object.values(obj).forEach((value) => {
      if (typeof value === 'string') {
        strings.push(value)
      } else if (typeof value === 'object' && value != null) {
        recursiveExtract(value)
      }
    })
  }

  recursiveExtract(data)
  return strings
}

/**
 * Show API error toasts.
 * Supports legacy `handleError(err)` and `handleError(err)`.
 */
export default function handleError(a, b) {
  const err = arguments.length >= 2 ? b : a

  if (err?.response?.data?.code) {
    const { code, detail } = err.response.data
    if (code.toString().charAt(0) === '5') {
      window.location.replace(
        `${window.location.protocol}//${window.location.hostname}${
          window.location.port ? `:${window.location.port}` : ''
        }/internal-error`,
      )
    } else if (ErrorCodes[code]) {
      showErrorSnackbar(ErrorCodes[code].detail)
    } else {
      showErrorSnackbar(detail)
    }
  }
  // backward compatibility starts
  else if (err?.response?.status === 401) {
    if (
      err?.response?.data?.detail !== 'Given token not valid for any token type'
    )
      showErrorSnackbar(err.response.data.detail)
  } else if (err?.response?.status === 400) {
    const values = extractStrings(err.response.data)
    values.forEach((value) => {
      showErrorSnackbar(value)
    })
  } else if (err?.response?.status === 404) {
    showErrorSnackbar(err.response.data.detail)
    if (err?.response?.config?.url.match(/^\/batch\/([a-zA-Z0-9_-]+)\/?$/)) {
      window.location.replace(
        `${window.location.protocol}//${window.location.hostname}${
          window.location.port ? `:${window.location.port}` : ''
        }`,
      )
    }
  } else if (err?.response?.status.toString().charAt(0) === '5') {
    window.location.replace(
      `${window.location.protocol}//${window.location.hostname}${
        window.location.port ? `:${window.location.port}` : ''
      }/internal-error`,
    )
  }
  // backward compatibility ends
  else if (typeof err === 'string') {
    showErrorSnackbar(err)
  } else if (!err?.response) {
    showErrorSnackbar('Your request has timed out')
  } else {
    showErrorSnackbar('Something went wrong, please try contacting support!')
  }
}
